import { render, staticRenderFns } from "./OrderDetailModalContent.vue?vue&type=template&id=06940986&scoped=true&"
import script from "./OrderDetailModalContent.vue?vue&type=script&lang=js&"
export * from "./OrderDetailModalContent.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailModalContent.vue?vue&type=style&index=0&id=06940986&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06940986",
  null
  
)

export default component.exports